import React from 'react';
import {connect} from 'react-redux';
import {AppState} from '@Redux/store';

import {exportArmyListUnit} from '@Selectors/builder/myArmyList/export/exportArmyListUnit';
import {ArmyListUnit} from '@Models';

interface IArmyListUnitExportProps {
  armyListUnit: ArmyListUnit,
  showPoints: boolean,
  showDetails?: boolean
}

const ArmyListUnitExport: React.FC<ArmyListUnitExportProps> = ({ unitText }) => {
  return (
    <p>{unitText}</p>
  );
};

const mapStateToProps = (state: AppState, owsProps: IArmyListUnitExportProps) => ({
  unitText: exportArmyListUnit(state, owsProps)
})

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListUnitExport);

type ArmyListUnitExportProps = ReturnType<typeof mapDispatchToProps> &
                          ReturnType<typeof mapStateToProps>
